(function(){
  const excluded=new Set(["inicial-mini-oro","inicial-mini-plata","initial-midi-oro","inicial-midi-plata","servicio-de-limpieza-joyas-plata-de-ley","servicio-de-limpieza-joyas-bano-de-oro","anadir-alargo-de-5-cm-bano-de-oro","anadir-alargo-de-5-cm-plata-de-ley","stock-alargos-joyas"]);
  function excludeInternalProducts(){
    const found=document.cookie.split("; ").find(x=>x.startsWith("shopify_recently_viewed="));
    if(!found)return;
    const values=decodeURIComponent(found.slice("shopify_recently_viewed=".length)).split(" ");
    const clean=values.filter(v=>v&&!excluded.has(v));
    if(clean.length===values.length)return;
    const expiry=new Date(Date.now()+90*86400000).toUTCString();
    document.cookie="shopify_recently_viewed="+encodeURIComponent(clean.join(" "))+"; expires="+expiry+"; path=/; SameSite=Lax";
  }
  excludeInternalProducts();
  customElements.get("recently-viewed")||customElements.define("recently-viewed",class extends HTMLElement{
    constructor(){super();this.section=this.closest("related-products");this.sectionId=this.section?.dataset.sectionId;this.howManyToShow=parseInt(this.dataset.limit)||3}
    connectedCallback(){
      excludeInternalProducts();
      const holder=document.getElementById("recently-viewed-products-"+this.sectionId);
      if(holder){
        const excludedLinks=["inicial-mini-oro","inicial-mini-plata","initial-midi-oro","inicial-midi-plata","servicio-de-limpieza-joyas-plata-de-ley","servicio-de-limpieza-joyas-bano-de-oro","anadir-alargo-de-5-cm-bano-de-oro","anadir-alargo-de-5-cm-plata-de-ley","stock-alargos-joyas"];
        const removeCards=()=>{
          holder.querySelectorAll('a[href*="/products/"]').forEach(a=>{
            if(!excludedLinks.some(handle=>a.getAttribute("href")?.split("?")[0].endsWith("/products/"+handle)))return;
            const card=a.closest("[data-product-block],.product-grid-item,.grid__item,.carousel__item");
            if(card && holder.contains(card))card.remove();
          });
        };
        new MutationObserver(removeCards).observe(holder,{childList:true,subtree:true});
        removeCards();
      }
      Shopify.Products.showRecentlyViewed({howManyToShow:this.howManyToShow,wrapperId:"recently-viewed-products-"+this.sectionId,section:this.section,onComplete:e=>{e.parentElement.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:false}))}})
    }
  });
})();